import React from "react";
import { motion } from "framer-motion";

const REVIEWS = [
  {
    quote:
      "Booked Jaybliss for our office move from Belfast to Lisburn. On time, professional, and every desk arrived scratch-free.",
    name: "Ciara O'Neill",
    role: "Office Manager · Belfast",
  },
  {
    quote:
      "They packed our whole three-bed house in a morning. Careful, calm, and honestly the best value we could find.",
    name: "James McKenna",
    role: "Homeowner · Bangor",
  },
  {
    quote:
      "Doorstep delivery from Belfast to Manchester. Kept us informed the whole way. Ten out of ten.",
    name: "Aoife Doherty",
    role: "Online Seller",
  },
];

export default function Testimonials() {
  return (
    <section className="bg-[var(--jb-bone)] py-24 md:py-32" data-testid="testimonials-section">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="grid md:grid-cols-12 gap-8 mb-16"
        >
          <div className="md:col-span-1 mono-cap text-[var(--jb-rust)]">(Reviews)</div>
          <h2 className="md:col-span-11 serif text-[clamp(36px,5vw,72px)] leading-[1] tracking-tight text-[var(--jb-navy)]">
            Trusted by movers <br />
            <span className="italic">across Northern Ireland.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {REVIEWS.map((r, i) => (
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="bg-white p-8 md:p-10 border border-[var(--jb-line)] relative"
              data-testid={`testimonial-${i}`}
            >
              <div className="serif text-6xl text-[var(--jb-rust)] leading-none mb-4">“</div>
              <p className="serif italic text-[20px] md:text-[22px] leading-[1.4] text-[var(--jb-navy)]">
                {r.quote}
              </p>
              <footer className="mt-8 pt-6 border-t border-[var(--jb-line)]">
                <div className="mono-cap text-[var(--jb-navy)]">{r.name}</div>
                <div className="text-[13px] text-[var(--jb-muted)] mt-1">{r.role}</div>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
